<style scoped>
.collapsible-header:hover {
  background-color: rgba(230, 230, 230, 0.626);
}

.collapsible-body {
  padding: 0;
}

.collapsible-header {
  text-transform: capitalize;
}

.collapsible-header span.counter {
  flex-grow: 1;
}

.collapsible-header:focus {
  outline: none;
}

.collapsible-body li {
  display: block;
  padding: 18px 24px;
}

.collapsible-body li:not(:last-child) {
  border-bottom: 1px solid lightgray;
}
.orderitm {
  display: grid;
}
.orderitm > li {
  padding: 10px 20px;
  border-bottom: 1px solid #e0e0e0;
}
li.waves-effect.active {
  background: #b03236;
  color: white !important;
}
li.waves-effect.active p {
  color: white !important;
}
</style>

<template lang="pug">
li
  .collapsible-header(:class='getStatusClass(status)') {{ status }}
    span.right-align.counter(v-if='filteredOrders.length > 0') {{ filteredOrders.length }}
  //- .collapsible-body
  div
    ul.orderitm(v-if='filteredOrders.length > 0')
      li.waves-effect(
        v-for='(order, index) in filteredOrders',
        :class='{ active: activeIndexId === order.id && !searching }',
        @click='viewOrder(order, index)'
      )
        p.title.small.no-margin {{ order.referenceNumber }}
        p.subtitle.micro {{ $utils.formatter.formatLongDateTime(order.createdAt) }}
    .center-align(v-else)
      .vspace.small
      p.grey-text No items available
      .vspace.small
</template>
<script>
export default {
  props: ['status', 'orders', 'searching', 'activeIndexId', 'filterBy'],
  data () {
    return {
      activeIndex: '',
      STATUS_NEW: 'new',
      STATUS_DECLINED: 'declined',
      STATUS_CANCELLED: 'cancelled',
      STATUS_PROCESSING: 'processing',
      STATUS_INTRANSIT: 'in-transit',
      STATUS_DELIVERED: 'delivered'
    }
  },
  computed: {
    filteredOrders () {
      if (!this.orders || this.orders.length === 0) {
        return []
      }

      let filteredOrders = []

      this.orders.forEach((order) => {
        const isNew = order.orderItems.some((orderItem) => {
          return orderItem.status.toLowerCase() === this.status
        })

        if (isNew) {
          filteredOrders.push(order)
        }
      })
      let filtered = filteredOrders
      if (this.filterBy !== null && this.filterBy.length) {
        filtered = filteredOrders.filter((order) => {
          return order.referenceNumber.includes(this.filterBy.toUpperCase())
        })
      }
      return filtered
    }
  },
  methods: {
    getStatusClass (status) {
      return {
        'indigo-text': status === this.STATUS_NEW,
        'green-text': status === this.STATUS_DELIVERED,
        'red-text':
          status === this.STATUS_DECLINED || status === this.STATUS_CANCELLED,
        'blue-text': status === this.STATUS_INTRANSIT,
        'orange-text': status === this.STATUS_PROCESSING
      }
    },
    viewOrder (order, index) {
      this.$emit('viewOrder', order)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-filtered-order-list.vue